/**
 * splitFaceImages.js — Shared AI split-face teaser catalogue.
 *
 * The 11 AI-generated BEFORE/AFTER composites (same subject, left half =
 * current, right half = future/after treatment) used across:
 *   • Client Portal · FutureSelfPeekCard   (rotating card)
 *   • Homepage · HomeAIFutureBox           (floating tile — Feb 6 2026)
 *   • Lobby TV · lobbyFreshDeck            (fullscreen signage — Feb 6 2026)
 *
 * Karine ask (Feb 6 2026): push AI Skin Analysis exposure hard — the
 * homepage floating tile and multiple lobby-TV slides now use these same
 * assets to build brand recall.
 */
export const SPLIT_FACE_IMAGES = [
  {
    id: "split-aging",
    src: "/generated/split-aging.png",
    alt: "Split face — today vs aged 10 years without treatment",
    labelLeft:  { en: "Today",     fr: "Aujourd'hui" },
    labelRight: { en: "+10 Years", fr: "+10 Ans" },
    tagline:    { en: "10 years without treatment", fr: "10 ans sans traitement" },
  },
  {
    id: "split-brow-lift",
    src: "/generated/split-brow-lift.png",
    alt: "Split face — before vs after a brow lift",
    labelLeft:  { en: "Before",    fr: "Avant" },
    labelRight: { en: "Brow Lift", fr: "Lift des Sourcils" },
    tagline:    { en: "See yourself with a brow lift", fr: "Vous, avec un lift des sourcils" },
  },
  {
    id: "split-filler",
    src: "/generated/split-filler.png",
    alt: "Split face — before vs after dermal filler",
    labelLeft:  { en: "Before",       fr: "Avant" },
    labelRight: { en: "Dermal Filler", fr: "Fillers" },
    tagline:    { en: "See yourself with dermal filler", fr: "Vous, avec des fillers" },
  },
  {
    id: "split-smile-lift",
    src: "/generated/split-smile-lift.png",
    alt: "Split face — before vs after a smile lift",
    labelLeft:  { en: "Before",     fr: "Avant" },
    labelRight: { en: "Smile Lift", fr: "Lift du Sourire" },
    tagline:    { en: "See yourself with a smile lift", fr: "Vous, avec un lift du sourire" },
  },
  {
    id: "split-lip-filler",
    src: "/generated/split-lip-filler.png",
    alt: "Split face — before vs after lip filler",
    labelLeft:  { en: "Before",     fr: "Avant" },
    labelRight: { en: "Lip Filler", fr: "Fillers Lèvres" },
    tagline:    { en: "See yourself with lip filler", fr: "Vous, avec des fillers de lèvres" },
  },
  {
    id: "split-jawline",
    src: "/generated/split-jawline.png",
    alt: "Split face — before vs after jawline contour",
    labelLeft:  { en: "Before",         fr: "Avant" },
    labelRight: { en: "Jawline Contour", fr: "Contour Mâchoire" },
    tagline:    { en: "See yourself with a defined jawline", fr: "Vous, avec une mâchoire définie" },
  },
  {
    id: "split-skin-tone",
    src: "/generated/split-skin-tone.png",
    alt: "Split face — before vs after skin tone evening treatment",
    labelLeft:  { en: "Before",   fr: "Avant" },
    labelRight: { en: "Even Skin", fr: "Peau Uniforme" },
    tagline:    { en: "See yourself with clear even skin", fr: "Vous, avec une peau uniforme" },
  },
  {
    id: "split-male-botox",
    src: "/generated/split-male-botox.png",
    alt: "Split face — man before vs after Botox (frown lines relaxed)",
    labelLeft:  { en: "Before",  fr: "Avant" },
    labelRight: { en: "Botox",   fr: "Botox" },
    tagline:    { en: "For him — softer frown lines with Botox",
                  fr: "Pour lui — des rides du lion adoucies au Botox" },
  },
  {
    id: "split-male-undereye",
    src: "/generated/split-male-undereye.png",
    alt: "Split face — man before vs after under-eye treatment",
    labelLeft:  { en: "Before",         fr: "Avant" },
    labelRight: { en: "Brighter Eyes",  fr: "Regard Reposé" },
    tagline:    { en: "For him — refreshed rested under-eyes",
                  fr: "Pour lui — un regard reposé" },
  },
  {
    id: "split-male-jawline",
    src: "/generated/split-male-jawline.png",
    alt: "Split face — man before vs after jawline sculpting",
    labelLeft:  { en: "Before",         fr: "Avant" },
    labelRight: { en: "Sharp Jawline",  fr: "Mâchoire Nette" },
    tagline:    { en: "For him — a sharper defined jawline",
                  fr: "Pour lui — une mâchoire plus nette" },
  },
  {
    id: "split-male-aging",
    src: "/generated/split-male-aging.png",
    alt: "Split face — man today vs aged 10 years without treatment",
    labelLeft:  { en: "Today",     fr: "Aujourd'hui" },
    labelRight: { en: "+10 Years", fr: "+10 Ans" },
    tagline:    { en: "For him — 10 years without treatment",
                  fr: "Pour lui — 10 ans sans traitement" },
  },
];
